// Distance calculation utilities using Haversine formula

const EARTH_RADIUS_MILES = 3958.8 // Earth's radius in miles

// Calculate distance between two coordinates using Haversine formula
export function haversineDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180

  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return EARTH_RADIUS_MILES * c
}

// Format distance for display
export function formatDistance(miles: number): string {
  if (miles < 0.1) {
    return '< 0.1 mi'
  }
  if (miles < 10) {
    return `${miles.toFixed(1)} mi`
  }
  return `${Math.round(miles)} mi`
}

// Sort theaters by distance from user location
export function sortByDistance<T extends { latitude?: number; longitude?: number }>(
  items: T[],
  userLat: number,
  userLng: number
): (T & { distance: number })[] {
  return items
    .map(item => ({
      ...item,
      distance: item.latitude && item.longitude
        ? haversineDistance(userLat, userLng, item.latitude, item.longitude)
        : Infinity,
    }))
    .sort((a, b) => a.distance - b.distance)
}
